import React from "react";
import { Link } from "react-router-dom";
import { ChevronRightIcon, BoxIcon } from "lucide-react";
interface SectionHeaderProps {
  icon: BoxIcon;
  iconClassName: string;
  title: string;
  linkTo: string;
}
export function SectionHeader({
  icon: Icon,
  iconClassName,
  title,
  linkTo
}: SectionHeaderProps) {
  return <div className="mb-3 flex items-center justify-between" data-id="element-73" data-mp="2j022fcgwsjf8">
      <div className="flex items-center gap-2" data-id="element-74" data-mp="1v8wm6w723p4e">
        <div className={`flex h-7 w-7 items-center justify-center rounded-lg ${iconClassName}`} data-id="element-75" data-mp="1v9pkd8ry96ax">
          <Icon className="h-4 w-4" data-id="element-76" data-mp="1qbo38te33h23" />
        </div>
        <h2 className="text-sm font-semibold text-slate-900" data-id="element-77" data-mp="24ypof6lb6rvz">{title}</h2>
      </div>
      <Link to={linkTo} className="flex items-center text-xs font-medium text-slate-400 transition-colors duration-150 hover:text-slate-600" data-id="element-78" data-mp="20899fi1uay7i">
        See all <ChevronRightIcon className="h-3.5 w-3.5" data-id="element-79" data-mp="1chdl4uwlel50" />
      </Link>
    </div>;
}